import { Stack, Typography } from '@mui/material';
import { usePrivy } from '@privy-io/react-auth';
import WalletButton from './WalletButton';
import { PropsWithChildren } from 'react';
import { useChainId, useConfig } from 'wagmi';
import { useEvmWallet } from '../hooks/useEvmWallet';

export default function IsConnectedWrapper({ children }: PropsWithChildren) {
  const { ready } = usePrivy();
  const chainId = useChainId();
  const { chains } = useConfig();

  // Use EVM wallet address (not the Privy embedded Solana wallet)
  const { isConnected } = useEvmWallet();
  const usingSupportedNetwork = chains.some((_chain) => _chain.id === chainId);

  // Must be authenticated via Privy with a connected wallet on a supported network
  const isFullyConnected = ready && isConnected && usingSupportedNetwork;

  return (
    <>
      {isFullyConnected ? (
        <>{children}</>
      ) : (
        <Stack sx={{ my: 4, gap: 2, alignItems: 'center' }}>
          <Typography>
            Connect your wallet to get started with using the Shinkai Identity
            Center
          </Typography>
          <WalletButton />
        </Stack>
      )}
    </>
  );
}
